import { useSelector } from 'react-redux';
import { catalogItemSelector } from './store';

export const useCatalogItem = () => useSelector(catalogItemSelector);
